module.exports = __webpack_public_path__ + "media/images/icons/page-10c11a4447bd2699a1b71e39225ebb21.svg";